import { Loader2, Save, Undo2 } from "lucide-react";

// Fixed bar that appears the moment a page has unsaved edits, so nobody has to scroll back to
// the top to find Save (the owner's words: "really stupid"). Sits above the phone's bottom
// inset and clear of the desktop sidebar.
export function StickySaveBar({ dirty, saving, onSave, onDiscard, label = "Unsaved changes", testid = "sticky-save" }) {
  if (!dirty) return null;
  return (
    <div data-testid={`${testid}-bar`} role="status"
      className="fixed inset-x-0 bottom-0 z-40 lg:left-64 px-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-2 pointer-events-none">
      <div className="pointer-events-auto mx-auto flex max-w-3xl items-center gap-2 rounded-2xl border border-amber-200 bg-white/95 px-3 py-2 shadow-[0_12px_40px_rgba(0,0,0,0.18)] backdrop-blur sm:gap-3 sm:px-4">
        <span className="h-2 w-2 shrink-0 rounded-full bg-amber-500 animate-pulse" />
        <span className="min-w-0 flex-1 truncate text-sm font-semibold text-ink">{label}</span>
        {onDiscard && (
          <button type="button" data-testid={`${testid}-discard`} onClick={onDiscard} disabled={saving}
            className="inline-flex items-center gap-1.5 rounded-full px-3 py-2 text-xs font-semibold text-ink/60 hover:bg-sand-100 hover:text-ink disabled:opacity-50">
            <Undo2 className="h-3.5 w-3.5" /> <span className="hidden sm:inline">Discard</span>
          </button>
        )}
        <button type="button" data-testid={`${testid}-save`} onClick={onSave} disabled={saving}
          className="inline-flex items-center gap-2 rounded-full bg-ink px-4 py-2 text-sm font-semibold text-white hover:bg-ink-700 disabled:opacity-50">
          {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} Save
        </button>
      </div>
    </div>
  );
}
